import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Pencil, KeyRound } from "lucide-react";

const FIELDS = [["first_name", "Nome"], ["last_name", "Cognome"], ["phone", "Telefono"], ["email", "Email"], ["dob", "Data di nascita"], ["barcode", "Codice a barre carta plastica (EAN-13 / CODE-128)"], ["address", "Indirizzo"], ["zip_code", "CAP"], ["city", "Città"], ["province", "Provincia"], ["notes", "Note"]];

// Admin: modifica anagrafica cliente + impostazione nuova password portale
export default function CustomerEditPanel({ customer, onSaved }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({});
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const start = () => { setForm(Object.fromEntries(FIELDS.map(([k]) => [k, customer[k] || ""]))); setPwd(""); setOpen(true); };
  const save = async () => {
    setBusy(true);
    try {
      const payload = Object.fromEntries(FIELDS.map(([k]) => [k, form[k] ?? ""]));
      if (!payload.first_name.trim() || !payload.last_name.trim() || !payload.phone.trim()) { toast.error("Nome, cognome e telefono sono obbligatori"); return; }
      const { data } = await api.patch(`/customers/${customer.id}`, payload);
      if (pwd) {
        if (pwd.length < 6) { toast.error("La password deve avere almeno 6 caratteri"); return; }
        await api.put(`/customers/${customer.id}/password`, { password: pwd });
      }
      toast.success(pwd ? "Anagrafica e password aggiornate" : "Anagrafica aggiornata");
      setOpen(false); onSaved?.(data);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const gen = () => setPwd(Math.random().toString(36).slice(2, 6) + Math.floor(1000 + Math.random() * 9000));
  return (
    <>
      <Button variant="outline" size="sm" onClick={start} className="w-full border-zinc-700" data-testid="customer-edit-open"><Pencil className="h-3.5 w-3.5 mr-1" /> Modifica anagrafica / password</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg bg-zinc-950 border-zinc-800 max-h-[90vh] overflow-y-auto" data-testid="customer-edit-dialog">
          <DialogHeader><DialogTitle className="font-heading">Modifica cliente · {customer.card_number}</DialogTitle></DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            {FIELDS.map(([k, label]) => (
              <div key={k} className={["name", "address", "notes", "email"].includes(k) ? "col-span-2" : ""}>
                <Label className="text-[11px] text-zinc-500">{label}</Label>
                <Input type={k === "dob" ? "date" : "text"} value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="bg-zinc-900 border-zinc-800" data-testid={`customer-edit-${k}`} />
              </div>
            ))}
          </div>
          <div className="rounded-lg border border-amber-500/30 bg-amber-500/5 p-3 space-y-2">
            <Label className="text-[11px] text-amber-300 flex items-center gap-1"><KeyRound className="h-3 w-3" /> Nuova password portale (lascia vuoto per non cambiarla)</Label>
            <div className="flex gap-2">
              <Input value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="min. 6 caratteri" className="bg-zinc-900 border-zinc-800 font-mono" data-testid="customer-edit-password" />
              <Button type="button" variant="outline" onClick={gen} className="border-zinc-700 shrink-0" data-testid="customer-edit-password-gen">Genera</Button>
            </div>
            <p className="text-[10px] text-zinc-500">Comunica la password al cliente di persona o via WhatsApp; potrà cambiarla dal portale.</p>
          </div>
          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={() => setOpen(false)} className="border-zinc-700" data-testid="customer-edit-cancel">Annulla</Button>
            <Button onClick={save} disabled={busy} className="bg-[color:var(--paprika)] hover:bg-[color:var(--paprika-hover)]" data-testid="customer-edit-save">{busy ? "Salvo…" : "Salva"}</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
